import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gztvfbkcg: FaireProductEntity = {
  token: "p_6gztvfbkcg",
  type: "product",
  name: "STANKONIA - An Outkast & Portrait Candle",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/ecfee320ad6c16513f97821b07fdcd644a79d0914ab13ecbfffa335e8c6ff41c.png",
  galleryImageUrls: [],
  priceDollars: 13.2,
  description: "Outkast and Portrait Coffee are celebrating 25 years of the groundbreaking album Stankonia with a limited-edition sensory experience.\n\nThe scent: Deep, atmospheric, and grounded. It blends Amber with smoky Black Oud to capture the soul of late-night creative sessions.\n\nQuick facts:\n\n * \nScent: Amber and Incense.\n\n * \nSpecs: 8 oz soy candle.\n\n * \nOrigin: Hand-poured by the Portrait Coffee team in Atlanta’s West End.\n\nPro tips:\n\n * \nTrim it: Keep the wick at 1/4 inch before every use for a better burn.\n\n * \nSet the memory: Let the wax melt across the entire surface on the first light to avoid tunneling.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:37.446Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
